<template>
    <div>
        <planning-calendar-event-modal></planning-calendar-event-modal>
        <planning-calendar-event-form-modal></planning-calendar-event-form-modal>
        <planning-calendar-event-context-menu></planning-calendar-event-context-menu>

        <planning-time-activity-modal></planning-time-activity-modal>
        <planning-time-activity-form-modal></planning-time-activity-form-modal>
        <planning-time-activity-context-menu></planning-time-activity-context-menu>
    </div>
</template>

<script>
    import PlanningTimeActivityModal from './TimeActivity/Modal.vue';
    import PlanningTimeActivityFormModal from './TimeActivity/FormModal.vue';
    import PlanningTimeActivityContextMenu from './TimeActivity/ContextMenu.vue';
    import PlanningCalendarEventModal from './CalendarEvent/Modal.vue';
    import PlanningCalendarEventFormModal from './CalendarEvent/FormModal.vue';
    import PlanningCalendarEventContextMenu from './CalendarEvent/ContextMenu.vue';
    
    export default {
        components: {
            PlanningTimeActivityModal,
            PlanningTimeActivityFormModal,
            PlanningTimeActivityContextMenu,
            PlanningCalendarEventModal,
            PlanningCalendarEventFormModal,
            PlanningCalendarEventContextMenu
        }
    }
</script>